export interface MotOpportunity {
    vehicleMOTOpportunityID: number
    dealerID: number
    vehicleID: number
    registration: string
    customerName: string
    email: string
    phone: string
    motExpiryDate: Date | null
    followUpStatus: string
}
export const MotOpportunityInit = () => {
    return {
        vehicleMOTOpportunityID: 0,
        dealerID: 0,
        vehicleID: 0,
        registration: "",
        customerName: "",
        email: "",
        phone: "",
        motExpiryDate: null,
        followUpStatus: "",
    }
}
export interface ErrorMessage {
    error: string
    description: string | null
}

export const FollowUpStatus = ["Open", "Closed", "Called"]
